module.exports = __webpack_public_path__ + "img/arrow-left.59b33824.svg";